import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Translations from './loader.js';

Vue.use(VueI18n);

let prefferedLanguage = 'en';
let savedLanguage = window.localStorage.getItem('headwear-crm-ui-language');

if (savedLanguage) {
  prefferedLanguage = savedLanguage.replace(/[^a-z]/gmi, '');
} else if (navigator && navigator.language) {
  prefferedLanguage = navigator.language;
  prefferedLanguage = prefferedLanguage.split('-');
  prefferedLanguage = prefferedLanguage[0];

  if (['pl', 'en', 'de', 'fr', 'it'].indexOf(prefferedLanguage) === -1) {
    prefferedLanguage = 'en';
  }
}

const i18n = new VueI18n({
  locale: prefferedLanguage,
  fallbackLocale: 'en',
  messages: Translations,
  pluralizationRules: {
    'pl': function (choice, choicesLength) {
      if (choice === 0) {
        return 0;
      }
      const teen = choice > 10 && choice < 20;
      const endsWithOne = choice % 10 === 1;
      if (choicesLength < 4) {
        return (!teen && endsWithOne) ? 1 : 2;
      }
      if (!teen && endsWithOne) {
        return 1;
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
      }
      return (choicesLength < 4) ? 2 : 3;
    },
    'fr': function (choice) {
      return (choice === 0 || choice === 1) ? 0 : 1;
    }
  }
});

export default i18n;
